import api from "../api";

const endpoint = {
	fetchPromotions: () => api.get("/promotion/list"),
};

export default endpoint;
